// Models
import Model from './Model'

class User extends Model {
  get schema () {
    return [
      'id',
      'passwordModified',
      'loggedIn',
      'email',
      'emailConfirmed',
      'phone',
      'phoneConfirmed',
      'language',
      'locked',
      'lockedTill',
      'lockComment',
      'credentialsExpired',
      'authyActivated',
      'whatsAppActivated',
      'tfaType',
      'tfaEnabled',
      'tfaEnabledModified',
      'legalAgreement',
      'privateAgreement',
      'selectedProfileId',
      'preSelectProfileType',
      'signEnabled',
      'authorities',
      'created',
      'modified',
      'firstName',
      'lastName'
    ]
  }
}

export default User
